<template>
  <div
    class="custom-token country-card card-condition connection-type"
    :class="{ noteq: model.predicate === 'NOT_EQUALS' || model.predicate === 'NOT_CONTAINS' }"
  >
    <ui-icon @click="emit('remove', model)" size="12" icon="fas fa-times" class="card-condition__close" />
    <div class="predicate-with-checkbox-wrapper mb-8">
      <ui-label class="mr-12" :text="t('Custom Token')" />

      <ui-input
        class="ml-8 ml-first-0"
        style="width: 180px"
        v-model="model.parameter"
        :placeholder="t('Parameter')"
        :hide-details="1"
      />

      <ui-select
        v-model="model.predicate"
        style="width: 200px"
        class="ml-8 ml-first-0"
        :items="model.predicateList"
        item-text="label"
        item-value="value"
        :autocomplete="false"
        :return-object="false"
        :hide-details="1"
      />

      <ui-checkbox
        v-model="hasEmpty"
        :label="t('Include empty value')"
        class="connection-type__checkbox ml-8 pt-0 pb-0"
      />
    </div>

    <div class="country-card__search">
      <ui-select
        v-model="selected"
        :placeholder="t('Add parameter values...')"
        :label="t('Searchable')"
        :items="model.values"
        :hide-details="2"
        item-title="text"
        item-value="value"
        multiple
        chips
        combobox
        multi-line
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@/composables';
import type { FlowTokenModel } from './useFlowTokenModelsCondition';
import { useFlowTokenForm } from './useFlowTokenForm';

const props = defineProps<{
  model: FlowTokenModel;
  emptyValue: { text: string; value: string };
}>();

const emit = defineEmits<{
  remove: [model: FlowTokenModel];
}>();

const { t } = useI18n();

const { selected, hasEmpty } = useFlowTokenForm(props.model, props.emptyValue);
</script>
